import {
  logoByPlatform,
  markByPlatform,
  nameByPlatform,
} from "~/constants/platfroms";
import type { IOption } from "~/types/option";
import { PlatformEnum } from "~/types/platform";

const filterIconByPlatform: Record<PlatformEnum, string> = {
  ...logoByPlatform,
  [PlatformEnum.LIMITLESS]: markByPlatform[PlatformEnum.LIMITLESS],
  [PlatformEnum.OPINION]: markByPlatform[PlatformEnum.OPINION],
};

export const platformFilterOptions: IOption<PlatformEnum>[] = Object.values(
  PlatformEnum
).map((platform) => ({
  label: nameByPlatform[platform],
  value: platform,
  iconSrc: filterIconByPlatform[platform],
}));
